import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import toastr from 'toastr';
import { getUser } from '../../../../../actions/shared/user/UserActions';
import { LOGGED_IN_USER_URL } from '../../../../../services/api/auth/AuthUrl';
import { API_URL, header, DATA_ANALYSIS } from '../../../../../utils/config';
import DataAnalysisNavBar from '../../../../layouts/data-analysis/DataAnalysisNavBar';

const CLOUD_PLANS_URL = `${API_URL}/cloud/admin/plans`;

const initialFormState = {
  name: '',
  slug: '',
  vcpus: '',
  ram_mb: '',
  disk_gb: '',
  price: '',
  active: true,
};

class DataAnalysisPlans extends Component {
  static propTypes = {
    getUser: PropTypes.func.isRequired,
    user: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  state = {
    plans: [],
    isLoading: false,
    isSaving: false,
    form: initialFormState,
  };

  componentDidMount() {
    this.props.getUser();
    this.checkDepartment();
    this.getPlans();
  }

  checkDepartment = async () => {
    try {
      const response = await axios.get(`${LOGGED_IN_USER_URL}`, header);

      if (response.data.department_id !== `${DATA_ANALYSIS}`) {
        this.props.history.push('/');
        sessionStorage.clear();
        toastr.info('You are not allowed to view this page');
      }
    } catch (e) {
      console.log(e.response);
    }
  };

  getPlans = async () => {
    this.setState({ isLoading: true });
    try {
      const response = await axios.get(CLOUD_PLANS_URL, header);
      this.setState({ plans: response.data.result || response.data.plans || response.data || [] });
    } catch (e) {
      toastr.error('Error fetching plans');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({ form: { ...prevState.form, [name]: value } }));
  };

  onToggleActive = (e) => {
    const { checked } = e.target;
    this.setState((prevState) => ({ form: { ...prevState.form, active: checked } }));
  };

  createPlan = async (e) => {
    e.preventDefault();
    const { form } = this.state;

    const payload = {
      name: form.name,
      slug: form.slug,
      vcpus: Number(form.vcpus),
      ram_mb: Number(form.ram_mb),
      disk_gb: Number(form.disk_gb),
      price: Number(form.price),
      active: form.active,
    };

    this.setState({ isSaving: true });
    try {
      await axios.post(CLOUD_PLANS_URL, payload, header);
      toastr.success('Plan created successfully');
      this.setState({ form: initialFormState });
      document.getElementById('close-create-plan').click();
      this.getPlans();
    } catch (e) {
      const message = e.response && e.response.data && e.response.data.message;
      toastr.error(message || 'Error creating plan');
    } finally {
      this.setState({ isSaving: false });
    }
  };

  render() {
    const { user } = this.props;
    const { firstName } = user;
    const { plans, isLoading, isSaving, form } = this.state;
    const nf = new Intl.NumberFormat();

    const isFormValid =
      form.name && form.slug && form.vcpus && form.ram_mb && form.disk_gb && form.price;

    return (
      <div className="s-layout">
        <main className="s-layout__content col-lg-10 p-0">
          <DataAnalysisNavBar currentPage="Plans" position={firstName} />

          <div className="col-12 after-summary">
            <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-3">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-3 text-right">
                  <button className="btn btn-green" data-toggle="modal" data-target="#create-plan">
                    Add Plan
                  </button>
                </div>

                <div className="card x-panel">
                  <div className="table-responsive content">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Slug</th>
                          <th>vCPUs</th>
                          <th>RAM (MB)</th>
                          <th>Disk (GB)</th>
                          <th>Price</th>
                          <th>Active</th>
                        </tr>
                      </thead>

                      <tbody>
                        {isLoading && (
                          <tr>
                            <td colSpan="8" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}

                        {!isLoading && plans.length === 0 && (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No plans found
                            </td>
                          </tr>
                        )}

                        {!isLoading &&
                          plans.map((plan, index) => (
                            <tr key={plan.id}>
                              <td>{index + 1}</td>
                              <td>{plan.name}</td>
                              <td>{plan.slug}</td>
                              <td>{plan.vcpus}</td>
                              <td>{nf.format(plan.ram_mb)}</td>
                              <td>{plan.disk_gb}</td>
                              <td>N {nf.format(plan.price)}</td>
                              <td>{plan.active ? 'Yes' : 'No'}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal fade" id="create-plan" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title mt-1">Add Plan</h4>
                  <button type="button" id="close-create-plan" className="close" data-dismiss="modal">
                    ×
                  </button>
                </div>

                <div className="modal-body">
                  <form className="form-horizontal" onSubmit={this.createPlan}>
                    <div className="form-group text-left">
                      <div className="col-md-12 mb-3 d-flex">
                        <div className="col-lg-6">
                          <label className="copy-font">Name</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Plan Name"
                            value={form.name}
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="copy-font">Slug</label>
                          <input
                            type="text"
                            name="slug"
                            className="form-control"
                            placeholder="plan-slug"
                            value={form.slug}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 mb-3 d-flex">
                        <div className="col-lg-6">
                          <label className="copy-font">vCPUs</label>
                          <input
                            type="number"
                            name="vcpus"
                            className="form-control"
                            placeholder="vCPUs"
                            value={form.vcpus}
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="copy-font">RAM (MB)</label>
                          <input
                            type="number"
                            name="ram_mb"
                            className="form-control"
                            placeholder="RAM in MB"
                            value={form.ram_mb}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 mb-3 d-flex">
                        <div className="col-lg-6">
                          <label className="copy-font">Disk (GB)</label>
                          <input
                            type="number"
                            name="disk_gb"
                            className="form-control"
                            placeholder="Disk in GB"
                            value={form.disk_gb}
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="copy-font">Price</label>
                          <input
                            type="number"
                            name="price"
                            className="form-control"
                            placeholder="Price"
                            value={form.price}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 mb-3">
                        <label className="copy-font">
                          <input type="checkbox" checked={form.active} onChange={this.onToggleActive} className="mr-2" />
                          Active
                        </label>
                      </div>
                    </div>

                    <div className="text-center mt-3">
                      {isSaving ? (
                        <button type="button" className="btn btn-green" disabled>
                          Creating...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-green" disabled={!isFormValid}>
                          Add Plan
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { getUser })(DataAnalysisPlans);
